export default {
    debug: true,
    state: {
        favItems: {
            data: [],
            required: true
        },
        favCurrentPage: {
            data: 1,
            required: true
        },
        localStorageFavs: {
            data: {},
            required: true
        },
        perPage: {
            data: process.env.NODE_ENV === 'production' ? 200 : 10,
            required: false
        },
    },
    getNowPageFavItems: function () {
        return this._fetchCurrentPageItems(this.state.favItems.data, this.state.favCurrentPage.data, this.state.perPage.data)
    },
    _fetchCurrentPageItems: function (items, currentPage, perPage) {
        const start = (currentPage - 1) * perPage
        const end = Math.min(start + perPage, items.length)
        return items.slice(start, end)
    },
    setFav: function (buttonSerialId, allItems, favState) {
        this.state.localStorageFavs.data[buttonSerialId] = favState
        const { item } = this._getButtonDataBySerialId(allItems, buttonSerialId)
        item.fav = favState

        if (favState === false) {
            const { idx } = this._getButtonDataBySerialId(this.state.favItems.data, buttonSerialId)
            this._removeFavItemByIdx(idx)
        } else {
            this._addFavItem(item)
        }
    },
    _getButtonDataBySerialId(items, buttonSerialId) {
        for(var idx = 0; idx < items.length; idx++ ){
            const item = items[idx]
            if(item.serialId === buttonSerialId) {
                return {item, idx}
            }
        }
        return undefined
    },
    _addFavItem: function (item) {
        this.state.favItems.data.push(item)
    },
    _removeFavItemByIdx: function (idx) {
        this.state.favItems.data.splice(idx, 1)
    },
    initFavItems: function (allItems) {
        this.state.favItems.data = allItems.filter(
            item => item.fav === true
        )
    },
    setLovalStorageFavs: function (localStorageFavs) {
        this.state.localStorageFavs.data = localStorageFavs
    },
    getLovalStorageFavs: function () {
        return this.state.localStorageFavs.data
    },
    getFavItems: function () {
        return this.state.favItems.data
    },
}
